import { FC } from 'react'
import { getImageDimensions, ImageEntityKey } from '../../config/imageDimensions'

type ImageDimensionHintProps = {
  // Soit on passe une entity key (recommandé : source de vérité centrale)
  entity?: ImageEntityKey
  // Soit on passe des valeurs explicites (override ponctuel)
  width?: number
  height?: number
  note?: string
}

const ImageDimensionHint: FC<ImageDimensionHintProps> = ({ entity, width, height, note }) => {
  let w = width
  let h = height
  let n = note

  if (entity) {
    const dims = getImageDimensions(entity)
    if (w === undefined) w = dims.width
    if (h === undefined) h = dims.height
    if (n === undefined) n = dims.note
  }

  if (!w || !h) return null

  return (
    <div className='form-text text-muted mt-1'>
      Dimensions recommandées : {w}×{h} px{n ? ` — ${n}` : ''}
    </div>
  )
}

export { ImageDimensionHint }
